import React, { useState, useRef, useEffect } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const LazyImage = ({ 
  src, 
  alt, 
  className, 
  style, 
  onLoad, 
  onError,
  placeholder = null,
  loadingHeight = '400px'
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: '50px'
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleLoad = (e) => {
    setIsLoaded(true);
    if (onLoad) onLoad(e);
  };

  const handleError = (e) => {
    setHasError(true);
    if (onError) onError(e);
  };

  const LoadingSpinner = () => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: loadingHeight,
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      flexDirection: 'column',
      color: '#666',
      ...style
    }}>
      <AiOutlineLoading3Quarters 
        size={48} 
        style={{ 
          animation: 'spin 1s linear infinite',
          marginBottom: '16px'
        }} 
      />
      <p>Loading image...</p>
    </div>
  );

  return (
    <div ref={imgRef} className={className} style={style}>
      {!src || hasError ? (
        placeholder || <LoadingSpinner />
      ) : !isInView ? (
        <LoadingSpinner />
      ) : (
        <>
          {!isLoaded && <LoadingSpinner />}
          <img
            src={src}
            alt={alt}
            onLoad={handleLoad}
            onError={handleError}
            style={{
              display: isLoaded ? 'block' : 'none',
              width: '100%',
              height: loadingHeight,
              objectFit: 'cover',
              borderRadius: '12px',
              ...style
            }}
          />
        </>
      )}
    </div>
  );
};

export default LazyImage;
